export default __webpack_public_path__ + "static/timik-febf26210dc7c6eb3eaf6dab5984d667.jpg";